package com.heelion.farmafreelance.ui

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp

/**
 * Campo password con l'occhio per mostrarla o nasconderla: serve a vedere cosa si è scritto
 * (es. una maiuscola messa dalla tastiera) prima di entrare o di salvarla.
 */
@Composable
fun CampoPassword(
    value: String,
    onValueChange: (String) -> Unit,
    label: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    supportingText: (@Composable () -> Unit)? = null
) {
    var visibile by remember { mutableStateOf(false) }
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        label = label,
        singleLine = true,
        visualTransformation = if (visibile) VisualTransformation.None else PasswordVisualTransformation(),
        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Password),
        trailingIcon = {
            IconButton(onClick = { visibile = !visibile }) {
                Icon(
                    imageVector = if (visibile) AppIcons.VisibilityOff else AppIcons.Visibility,
                    contentDescription = if (visibile) "Nascondi password" else "Mostra password"
                )
            }
        },
        modifier = modifier,
        shape = RoundedCornerShape(12.dp),
        isError = isError,
        supportingText = supportingText
    )
}
